import {
  useCustomer,
  useCustomerAddresses,
  useCustomerDefaultAddress,
  useCustomerRecoverPassword,
  useSettings,
} from '@backpackjs/storefront';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';

import AccountLayout from '../../../layouts/AccountLayout';
import { Body, Button, Headline, Spinner } from '../../../snippets';
import { AddressBookItem } from './AddressBookItem';
import { CreateAddressForm } from './CreateAddressForm';
import { EditAddressForm } from './EditAddressForm';

export function AddressBook() {
  const customer = useCustomer();
  const { recoverPassword, ...recoverPasswordStatus } =
    useCustomerRecoverPassword();
  const { addresses, ...status } = useCustomerAddresses();
  const defaultAddress = useCustomerDefaultAddress();
  const { asPath } = useRouter();
  const settings = useSettings();

  const [initialAddress, setInitialAddress] = useState(null);
  const [isCreateAddress, setIsCreateAddress] = useState(false);

  const recoverPasswordButtonText = useMemo(() => {
    if (recoverPasswordStatus.finished) {
      recoverPasswordStatus.resetTimer.current = setTimeout(() => {
        if (recoverPasswordStatus.reset) recoverPasswordStatus.reset();
        clearTimeout(recoverPasswordStatus.resetTimer.current);
      }, 3000);
      return recoverPasswordStatus.success
        ? 'Check your email'
        : 'Check your email';
    }
    return recoverPasswordStatus.started
      ? 'Sending reset password email'
      : 'Reset Password';
  }, [
    recoverPasswordStatus.finished,
    recoverPasswordStatus.started,
    recoverPasswordStatus.success,
  ]);

  const handleRecoverPassword = () => {
    if (customer.email) recoverPassword({ email: customer.email });
  };

  const { menuItems } = { ...settings?.account?.menu };
  const heading = menuItems?.find(({ link }) => asPath.startsWith(link?.url))
    ?.link?.text;

  return (
    <AccountLayout>
      <div className="flex flex-col gap-8 text-primary md:gap-10">
        <div className="grid gap-y-3">
          <div className="flex flex-col items-start justify-start gap-4 md:flex-row md:justify-between">
            <Headline variant="h4">Personal Info</Headline>
          </div>

          <Body variant="small" className="font-[500] max-md:text-[16px]">
            {customer?.email}
          </Body>
        </div>

        <div className="flex justify-end max-md:block">
          <Button
            theme="primary"
            variant="filled"
            className="max-md:w-full"
            aria-label="Add a new address"
            onClick={handleRecoverPassword}
            type="button"
          >
            {recoverPasswordButtonText}
          </Button>
        </div>
        {/* Sierra - Removed Address Book - Client UAT - 08/22/2023 (https://app.asana.com/0/1205253062894990/1205296196133872/f)
        <div className="flex flex-col items-start justify-start gap-4 md:flex-row md:justify-between">
          <Headline variant="h4" className="max-md:mb-[-28px]">
            {heading}
          </Headline>
        </div>

        {initialAddress && !isCreateAddress && (
          <EditAddressForm
            defaultAddress={defaultAddress}
            initialAddress={initialAddress}
            setInitialAddress={setInitialAddress}
          />
        )}

        {isCreateAddress && !initialAddress && (
          <CreateAddressForm setIsCreateAddress={setIsCreateAddress} />
        )}

        {status.started && !status.finished && (
          <div className="relative flex min-h-[12rem] items-center justify-center text-mediumGray">
            <Spinner width="32" />
          </div>
        )}

        {status.finished && !addresses?.length && (
          <div
            role="status"
            className="relative flex min-h-[12rem] items-center justify-center"
          >
            You don&#39;t have any addresses saved yet
          </div>
        )}
        {status.finished && defaultAddress && (
          <div className="">
            <AddressBookItem
              address={defaultAddress}
              defaultAddress={defaultAddress}
              initialAddress={initialAddress}
              setIsCreateAddress={setIsCreateAddress}
              setInitialAddress={setInitialAddress}
            />
          </div>
        )}

        <div className="flex justify-end">
          <Button
            theme="primary"
            variant="filled"
            aria-label="Add a new address"
            onClick={() => {
              setIsCreateAddress(true);
              setInitialAddress(null);
            }}
            type="button"
          >
            Add New Address
          </Button>
        </div> */}

        {/* {status.finished && !!addresses?.length && (
          <ul className="grid grid-cols-1 gap-6">
            {addresses.map((address) => {
              return (
                <li key={address.id}>
                  <AddressBookItem
                    address={address}
                    defaultAddress={defaultAddress}
                    initialAddress={initialAddress}
                    setIsCreateAddress={setIsCreateAddress}
                    setInitialAddress={setInitialAddress}
                  />
                </li>
              );
            })}
          </ul>
        )} */}
      </div>
    </AccountLayout>
  );
}
